import { environment } from '@/environments';
import Vue from 'vue';
import store from '@/store';
import i18n from '@/plugins/i18n';
import { PERMISSIONS } from '@/common/constants';
// import { loadRecaptchaScript } from '@/common/recaptcha';
import { getSidebarMenuList } from '@/router/helpers/getAppRoutes';
import {
  initSockets,
  loadWhiteLabel,
  loadBackendTranslations,
  loadSpecialitiesTranslations,
  getAccountByToken,
  setAccountTimezone,
  getClinicDetails,
  getClinicAdmins,
  getClinicDoctors,
  fetchClinics,
  getCurrencies,
  loadCountries,
  loadLanguages,
  showAppElements,
  setPillarCollect,
} from './startAppFunctions';

export async function startApp() {
  const buildId = environment.VUE_APP_BUILD_ID;
  const localId = localStorage.getItem('buildId');

  // TODO: remove check on undefined when the buildId is set by CI
  if (buildId !== undefined && localId !== buildId) {
    Vue.prototype.$clearCookies();
    localStorage.clear();
    sessionStorage.clear();
    localStorage.setItem('buildId', buildId);
  }

  if (location.pathname.includes('invitee')) {
    return;
  }
  console.log('startApp()');
  try {
    console.log('startApp() try');
    // for mobile!!!
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    store.commit('common/setAppLoading', true);

    const initialHash = location.hash?.replace('#', '');
    if (initialHash) {
      store.commit('common/setInitialHash', initialHash);
    }
    await fetchData();
  } catch (err) {
    console.log('startApp() catch');
    console.log(err);
  } finally {
    console.log('startApp() finally');
    store.commit('common/setAppLoading', false);
  }
}

export async function fetchData() {
  console.log('fetchData()');
  await fetchOtherData();
  // loadRecaptchaScript();
  await loadWhiteLabel();
  await loadBackendTranslations(localStorage.getItem('language') || i18n.locale || 'en');
  await fetchAccountData();
}

export async function fetchAccountData(token = localStorage.getItem('token')) {
  if (!token) throw { message: 'No token' };

  const account = await getAccountByToken(token);

  if (!account) throw { message: 'Error fetch account' };
  if (sessionStorage.getItem('isLoggedIn')) Vue.prototype.$setTabSession(account.username);

  await loadSpecialitiesTranslations(localStorage.getItem('language') || i18n.locale || 'en');
  await setAccountTimezone();
  await fetchDataByAccount(account);
}

async function fetchDataByAccount(account) {
  await initSockets();

  switch (account.role) {
    case 'CLINIC_ADMIN':
      if (account.permissions.find(p => p.name === PERMISSIONS.VIEW_CLINICS)) {
        await getClinicDetails(account.clinicIds);
        await setPillarCollect();
      }
      await getClinicAdmins();
      await getClinicDoctors();
      break;
    case 'SUPER_ADMIN':
      await getClinicDetails(account.clinicIds);
      await fetchClinics();
      await getCurrencies();
      break;
    case 'PROVIDER':
      await getClinicDetails(account.clinicIds);
      await getCurrencies(account.clinicIds[0]);
      break;
    case 'PATIENT':
      await getClinicDetails(account.clinicIds);
      await getCurrencies(account.clinicIds[0]);
      await setPillarCollect();
      break;
    default:
      break;
  }

  getSidebarMenuList(account);
  showAppElements();
}

async function fetchOtherData() {
  console.log('fetchOtherData()');
  try {
    console.log('fetchOtherData() try load countries');
    await loadCountries();
    await loadLanguages();
  } catch (e) {
    console.dir(e);
  }
}
